export default __webpack_public_path__ + "static/media/restriction.38750f42.webp";